export default __webpack_public_path__ + "static/media/ms-symbol.42b61fa1.svg";